import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import * as _ from 'lodash';
import { PopoverDirective } from 'ngx-bootstrap/popover';

import { CountriesService } from 'src/app/shared/services/countries.service';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CompanyIcpService } from 'src/app/components/company-icp/company-icp.service';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CompanyService } from 'src/app/settings/services/company.service';
import { GeodataService } from 'src/app/shared/services/geodata.service';
import { ValidationService } from 'src/app/shared/services/validation.service';
import { AiCreditsService } from '../../services/ai-credits.service';

@Component({
  selector: 'company-fields',
  templateUrl: './company-fields.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  styleUrls: ['./company-fields.component.scss'],
  standalone: false,
})
export class CompanyFieldsComponent implements OnInit, OnChanges {
  @ViewChildren(PopoverDirective) popovers: QueryList<PopoverDirective>;

  @Input() company: any = {};
  @Input() showManagedSections: boolean = false;
  @Output() resetAuthKeyEvent = new EventEmitter<string>();
  @Output() resetClaimIdEvent = new EventEmitter<string>();

  disableIndustry: boolean;
  isRiseStoreAdmin = this.userStateService.isRiseStoreAdmin();
  isRiseRootCompany = this.companyStateService.isRootCompanySelected();
  countries = this.countriesService.countries;
  public companyForm: NgForm;

  regionsCA = GeodataService.REGIONS_CA;
  regionsUS = GeodataService.REGIONS_US;
  COMPANY_INDUSTRY_FIELDS = this.sort(
    CompanyIcpService.COMPANY_INDUSTRY_FIELDS,
  );
  COMPANY_SIZE_FIELDS = CompanyIcpService.COMPANY_SIZE_FIELDS;

  WEBSITE_REGEX = ValidationService.WEBSITE_REGEX;
  EMAIL_REGEX = ValidationService.EMAIL_REGEX;
  PHONE_REGEX = ValidationService.PHONE_REGEX;
  isPublicationApprovalAvailable = this.featuresService.isFeatureAvailable(
    FeaturesService.FEATURE_PUBLICATION_APPROVAL,
  );

  constructor(
    private controlContainer: ControlContainer,
    private ngZone: NgZone,
    private countriesService: CountriesService,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    protected currentPlanService: CurrentPlanService,
    protected companyService: CompanyService,
    private featuresService: FeaturesService,
    private aiCreditsService: AiCreditsService,
  ) {}

  ngOnInit() {
    if (!this.company.settings) {
      this.company.settings = {};
    }

    this.companyForm = <NgForm>this.controlContainer;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.company) {
      this.disableIndustry =
        !!changes.company.currentValue.companyIndustry &&
        !this.userStateService.isRiseAdmin();
    }

    this.detectChanges();
  }

  sort(items) {
    return _.sortBy(items, (item) => {
      return item[0];
    });
  }

  resetAuthKey() {
    this.resetAuthKeyEvent.emit();
  }

  resetClaimId() {
    this.resetClaimIdEvent.emit();
  }

  disableSharePlanToggle() {
    return this.companyStateService.isRootCompanySelected();
  }

  detectChanges() {
    setTimeout(() => {
      this.ngZone.run(() => {});
    });
  }

  showPublishingApprovalUpgradePlanModal() {
    this.featuresService.showUpgradePlanModal(
      FeaturesService.FEATURE_PUBLICATION_APPROVAL,
    );
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.popovers.length > 0) {
      this.popovers.forEach((popover) => popover.hide());
    }
  }

  protected openCreditsModal(): void {
    this.aiCreditsService.openCreditsModal();
  }

  protected exportAICreditActivity(): void {
    this.aiCreditsService.sendReport();
  }
}
